import { CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";

const FinancialGoals = () => {
  return (
    <div className="relative w-full rounded-3xl py-20 bg-black-dark-100 overflow-hidden">
      {/* Subtle Background Glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary1/10 via-transparent to-primary1/5 pointer-events-none" />

      <section className="relative px-6 md:px-12 lg:px-24 text-center">
        {/* Heading */}
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl sm:text-4xl md:text-6xl xl:text-7xl font-bold text-white leading-tight">
            Your Financial <span className="text-primary1">Goals</span>, Our{" "}
            <span className="text-primary1">Priority</span>
          </h1>

          <p className="mt-6 text-base sm:text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed">
            From your first SIP to children’s education, home planning, and
            retirement we help you invest with clarity and confidence at every
            stage of life.
          </p>
        </div>

        {/* Key Benefits */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-4xl mx-auto justify-items-center text-center">
          {[
            "First SIP & Beginner Investing",
            "Family Financial Planning",
            "Tax-Efficient Long-Term Wealth",
            "Retirement Peace of Mind",
          ].map((item, index) => (
            <div key={index} className="flex items-center gap-3">
              <CheckCircle className="text-primary1 w-5 h-5 flex-shrink-0" />
              <span className="text-white text-base sm:text-lg">{item}</span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16">
          <Link
            to="/free-portfolio-check"
            className="inline-flex items-center justify-center px-10 py-4 text-base sm:text-lg bg-primary1 hover:scale-105 text-white rounded-2xl shadow-xl transition-all duration-300"
          >
            Free Portfolio Review →
          </Link>
        </div>
      </section>
    </div>
  );
};

export default FinancialGoals;
